import React from "react";
import { Link } from "react-router-dom";
import { Socials } from "../home";
const AboutUs = () => {
  return (
    <div className="min-h-screen relative overflow-hidden">
      {/* Background effects */}
      <div className="absolute inset-0 bg-gradient-to-b from-black via-black to-black/90 pointer-events-none"></div>
      <div className="absolute inset-0 bg-grid-pattern bg-[size:20px_20px] pointer-events-none opacity-[0.03]"></div>
      <div className="absolute top-40 -left-20 w-72 h-72 bg-market-teal/20 rounded-full blur-[120px] pointer-events-none"></div>
      <div className="absolute top-1/2 right-0 w-64 h-64 bg-market-teal/10 rounded-full blur-[100px] pointer-events-none"></div>

      <div className="container mx-auto px-4 py-16 pt-24 mt-12 relative z-10">
        <h1 className="text-4xl md:text-5xl font-bold text-white mb-8 text-center animate-fade-in">
          About MarketPulse Exchange
        </h1>

        <div
          className="max-w-4xl mx-auto text-white/80 space-y-6 text-lg animate-fade-in"
          style={{ animationDelay: "0.3s" }}
        >
          <p className="text-xl text-market-teal text-center mb-8">
            Where Momentum Meets Precision
          </p>

          <p>
            At marketpulse.exchange, our mission is clear: To help every trader
            and investor follow the money flow. In a market driven by momentum,
            timing is everything. Yet most traders miss out—not because they
            lack effort, but because they lack visibility. marketpulse.exchange
            solves this core problem by bringing institutional-level insights to
            everyday traders, in real time.
          </p>

          <p>
            We believe that successful trading isn't about prediction—it's about
            alignment. Our technology enables you to align with where the smart
            money is flowing, across sectors and stocks, every single minute.
          </p>

          <h2 className="text-2xl font-semibold text-white pt-8 mt-8">
            Our Mission
          </h2>
          <p>
            Empowering Smart Traders Through Real-Time Momentum Insights. We
            equip traders—beginners to pros—with real-time tools, predictive
            signals, and high-conviction entries based on market momentum and
            institutional behavior. Our goal? To help you stop guessing, start
            aligning, and grow consistently.
          </p>

          <h2 className="text-2xl font-semibold text-white pt-8 mt-8">
            Our Vision
          </h2>
          <p>
            A World Where Every Retail Trader Trades with Clarity. We envision a
            market where traders of all backgrounds and capital sizes can
            operate with the clarity, tools, and edge once reserved for hedge
            funds and prop desks.
          </p>

          <h2 className="text-2xl font-semibold text-white pt-8 mt-8">
            What Makes Us Different
          </h2>
          <ul className="list-disc list-inside space-y-3">
            <li>
              Built for Speed: Our Pi Scanner scans the NSE FnO universe every
              minute to identify momentum and breakout candidates
            </li>
            <li>
              Real-Time Signals: Know exactly when a stock gains strength, with
              predictive scores based on cumulative momentum
            </li>
            <li>
              Seamless Execution: Integrated with top brokers and algo platforms
              like Algotest
            </li>
            <li>
              Risk First. Always: Our tools guide you on how much to risk with
              Smart Position Sizing and Secure My Trade protocols
            </li>
          </ul>

          <h2 className="text-2xl font-semibold text-white pt-8 mt-8">
            Why Choose marketpulse.exchange?
          </h2>
          <p>
            Because in today's markets, information isn't enough—timing and
            insight are everything. We help you:
          </p>
          <ul className="list-disc list-inside space-y-3">
            <li>Find the right stocks before they move</li>
            <li>Enter with confidence and clarity</li>
            <li>Avoid overtrading and emotional decisions</li>
            <li>Focus on precision, not prediction</li>
          </ul>

          <div className="intellectia-card p-8 mt-12 text-center">
            <h3 className="text-xl font-semibold mb-4">Join the Movement</h3>
            <p className="mb-6">
              Thousands of traders are already shifting from noisy trading to
              data-driven conviction. Join the momentum revolution with
              marketpulse.exchange—where smart traders go to get smarter.
            </p>
            <Socials />
          </div>

          <p className="text-center text-xl text-market-teal mt-8">
            marketpulse.exchange — Follow the Money. Trade with Purpose.
          </p>
        </div>
      </div>
    </div>
  );
};

export default AboutUs;
